/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_New_Chat_BodyInputs */



/**
* | output |
* | --- |
* | "Start a fresh conversation with any available model. This is where most work begins." |
*
* @param {Onboarding_Tour_New_Chat_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_new_chat_body = /** @type {((inputs?: Onboarding_Tour_New_Chat_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_New_Chat_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Starte eine neue Unterhaltung mit jedem verfügbaren Modell. Hier beginnt die meiste Arbeit.")
	return /** @type {LocalizedString} */ ("Start a fresh conversation with any available model. This is where most work begins.")
});